import { useMemo } from "react";
import { useSelector } from "react-redux";

type DocumentSignMode = {
  resourceId: string;
  signMode: string;
};

type Stapel = {
  id?: number;
  localStapelId?: string;
  participantId: string;
  documentsSignModes?: DocumentSignMode[];
};

type Options = {
  includeCurrentStapel?: boolean;
};

export const StapelUseCount = (
  participantId: string,
  currentStapelId?: number,
  currentLocalStapelId?: string,
  options?: Options
) => {
  const stapeluser =
    useSelector((state: any) => state.user.userhavetostapelsigndocs) || [];

  const includeCurrent = options?.includeCurrentStapel ?? false;

  /**
   *  Relevante Stapel filtern
   */
  const relevantStapels = useMemo(() => {
    return stapeluser.filter((s: Stapel) => {
      if (s.participantId !== participantId) return false;

      if (!includeCurrent) {
        if (currentStapelId && s.id === currentStapelId) return false;
        if (
          currentLocalStapelId &&
          s.localStapelId === currentLocalStapelId
        )
          return false;
      }

      return true;
    });
  }, [
    stapeluser,
    participantId,
    currentStapelId,
    currentLocalStapelId,
    includeCurrent,
  ]);

  /**
   *  Usage-Count
   */
  const getUsageCount = (resourceId: string): number => {
    if (!resourceId) return 0;

    return relevantStapels.reduce((count: number, stapel: Stapel) => {
      const exists = stapel.documentsSignModes?.some(
        (d) => d.resourceId === resourceId
      );
      return exists ? count + 1 : count;
    }, 0);
  };

  return { getUsageCount };
};
